import jQuery from 'jquery';

export function initStickyNavbar() {
  attachStickyNavbar();
  window.addEventListener('resize', attachStickyNavbar, { passive: true });

  window.addEventListener('hashchange', function () {
    smoothScrollToHash();
  });
  window.addEventListener('popstate', function (event) {
    smoothScrollToHash();
    event.preventDefault();
  });
  smoothScrollToHash();

  if (window.history && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  jQuery('body').on('menloScroll', function (_evt, value) {
    smoothScrollToHash(value);
  });

  jQuery('body').on('click', 'a', function (this: HTMLAnchorElement, event: Event) {
    if (
      this.href &&
      (this.href.indexOf('#') === 0 ||
        this.href.indexOf(window.location.href.replace(/#.*$/, '') + '#') === 0)
    ) {
      event.preventDefault();
      smoothScrollToHash(this.href.replace(/^[^#]+/, ''));

      if (window.history && window.history.pushState) {
        window.history.pushState({}, document.title, this.href);
      }
    }
  });
}

function updateStickyNavbar() {
  const adminBarOffset = document.body.classList.contains('admin-bar')
    ? (document.getElementById('wpadminbar')?.getBoundingClientRect().height ?? 0)
    : 0;
  const navbarStickyOffset =
    jQuery('.js-sticky-navbar')[0].getBoundingClientRect().top +
    window.scrollY -
    adminBarOffset;
  if (window.scrollY > navbarStickyOffset) {
    jQuery('.js-sticky-navbar')
      .addClass('sticky')
      .css('height', jQuery('.js-sticky-navbar > *')[0].getBoundingClientRect().height);
  } else {
    jQuery('.js-sticky-navbar').removeClass('sticky');
  }
}

function attachStickyNavbar() {
  if (window.innerWidth < 768 || jQuery('.js-sticky-navbar').length === 0) {
    jQuery('.js-sticky-navbar').removeClass('sticky');
    window.removeEventListener('scroll', updateStickyNavbar);
  } else {
    window.addEventListener('scroll', updateStickyNavbar, { passive: true });
    updateStickyNavbar();
  }
}

function smoothScrollToElement(elem: HTMLElement, offset: number = defaultScrollOffset()) {
  const headerSmall = document.querySelector<HTMLElement>('.b-header-small');
  const headingElement = headerSmall ? headerSmall.offsetHeight * 2 : 0;
  const elemOffset = elem.getBoundingClientRect().top + window.scrollY;
  const targetPosition = elemOffset + offset - headingElement;

  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  } else {
    window.scrollTo(0, targetPosition);
  }
}

const navbarScrollOffset = -12;

function defaultScrollOffset() {
  return navbarScrollOffset - navbarHeight();
}

function navbarHeight() {
  return (jQuery('.js-sticky-navbar').height() || 0) + (jQuery('#wpadminbar').height() || 0);
}

function smoothScrollToHash(hash: string = window.location.hash) {
  if (hash) {
    const elem = document.getElementById(hash.replace(/^#/, ''));
    if (elem !== null) {
      smoothScrollToElement(elem);
    }
  } else {
    smoothScrollToElement(document.body);
  }
}
